import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  // Terreni actions
  setTerreni,
  addTerreni,
  updateTerreni,
  removeTerreni,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,

  // Enum actions
  setEsposizione,
  setTipoSuolo,
  setSistemaColtivazione,
  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure,
  addTerreniId,
  getCultura,
  getUliveto,
  getVarieta,
  setCultura,
  setUliveto,
  setVarieta,
} from "./terreniSlice";
import terreniAPI from "../../services/terreniAPI";
import { toast } from "react-toastify";

// Fetch all terreni
export const fetchTerreni = createAsyncThunk(
  "terreni/fetchTerreni",
  async (params, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await terreniAPI.getAllTerreni(params);
      console.log(response, "response")
      dispatch(setTerreni(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch single terreni
export const fetchSingleTerreni = createAsyncThunk(
  "terreni/fetchSingleTerreni",
  async (terreniId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await terreniAPI.getTerreni(terreniId);
      dispatch(addTerreniId(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Create terreni
export const createTerreni = createAsyncThunk(
  "terreni/createTerreni",
  async (terreniData, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await terreniAPI.createTerreni(terreniData);
      dispatch(addTerreni(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Update terreni
export const updateSingleTerreni = createAsyncThunk(
  "terreni/updateSingleTerreni",
  async ({ terreniId, terreniData }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await terreniAPI.updateTerreni(terreniId, terreniData);
      dispatch(updateTerreni(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Delete terreni
export const deleteTerreni = createAsyncThunk(
  "terreni/deleteTerreni",
  async (terreniId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
    const response =  await terreniAPI.deleteTerreni(terreniId);
      dispatch(removeTerreni(terreniId));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Duplicate terreni
export const duplicateTerreni = createAsyncThunk(
  "terreni/duplicateTerreni",
  async (terreniId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await terreniAPI.duplicateTerreni(terreniId);
      dispatch(addTerreni(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to duplicate terreni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch Enums
export const fetchEsposizione = createAsyncThunk(
  "terreni/fetchEsposizione",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('esposizione'));
    try {
      const response = await terreniAPI.getEsposizione();
      dispatch(setEsposizione(response.data.data));
      dispatch(enumRequestSuccess('esposizione'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch esposizione.";
      dispatch(enumRequestFailure({
        enumType: 'esposizione',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);

export const fetchTipoSuolo = createAsyncThunk(
  "terreni/fetchTipoSuolo",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('tipoSuolo'));
    try {
      const response = await terreniAPI.getTipoSuolo();
      dispatch(setTipoSuolo(response.data.data));
      dispatch(enumRequestSuccess('tipoSuolo'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tipo suolo.";
      dispatch(enumRequestFailure({
        enumType: 'tipoSuolo',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);

export const fetchSistemaColtivazione = createAsyncThunk(
  "terreni/fetchSistemaColtivazione",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('sistemaColtivazione'));
    try {
      const response = await terreniAPI.getSistemaColtivazione();
      dispatch(setSistemaColtivazione(response.data.data));
      dispatch(enumRequestSuccess('sistemaColtivazione'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch sistema coltivazione.";
      dispatch(enumRequestFailure({
        enumType: 'sistemaColtivazione',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);

export const fetchCultura = createAsyncThunk(
  "terreni/fetchCultura",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('cultura'));
    try {
      const response = await terreniAPI.getCultura();
      dispatch(setCultura(response.data.data));
      dispatch(enumRequestSuccess('cultura'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch cultura.";
      dispatch(enumRequestFailure({
        enumType: 'cultura',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);

export const fetchUliveto = createAsyncThunk(
  "terreni/fetchUliveto",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('uliveto'));
    try {
      const response = await terreniAPI.getUliveto();
      dispatch(setUliveto(response.data.data));
      dispatch(enumRequestSuccess('uliveto'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch uliveto.";
      dispatch(enumRequestFailure({
        enumType: 'uliveto',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);

export const fetchVarieta = createAsyncThunk(
  "terreni/fetchVarieta",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('varieta'));
    try {
      const response = await terreniAPI.getVarieta();
      dispatch(setVarieta(response.data.data));
      dispatch(enumRequestSuccess('varieta'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch varieta.";
      dispatch(enumRequestFailure({
        enumType: 'varieta',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);
